import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-event-area-item-slot-products',
  templateUrl: './booking-event-area-item-slot-products.component.html',
  styleUrls: ['./booking-event-area-item-slot-products.component.css']
})
export class BookingEventAreaItemSlotProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
